// Impostazioni i18n condivise tra server e frontend: le lingue supportate
// devono essere le stesse da entrambe le parti.
export const SUPPORTED_LOCALES = [ 'it', 'en' ] as const

export type SupportedLocale = typeof SUPPORTED_LOCALES[number]

export const FALLBACK_LOCALE: SupportedLocale = 'it'

export const DEFAULT_NAMESPACE = 'common'
